import { useEffect, useRef } from "react";
import { useLocation } from "@/lib/router-compat";
import { gtm } from "@/lib/gtm";
import { trackPageView } from "@/lib/analytics";

/**
 * SPA-aware GTM page_view tracker.
 * Place once inside BrowserRouter (e.g. in App.tsx).
 */
export function useGTMPageView() {
  const location = useLocation();
  const prev = useRef<string>("");

  useEffect(() => {
    const path = location.pathname + location.search;
    if (path !== prev.current) {
      const isFirst = prev.current === "";
      prev.current = path;
      gtm.pageView(path);
      // The initial view is sent by the gtag config call; only report moves.
      if (!isFirst) trackPageView(path);
    }
  }, [location]);
}
